var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgAttorney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#FFEADB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_110_790",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#D6E8F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_110_790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.2701 11.9751C57.2701 11.9751 70.1073 13.8997 69.1076 28.6575C68.1085 43.4135 79.445 38.443 80.1134 48.3874C80.7789 58.3329 83.1656 55.6216 85 62.9999C86.835 70.3794 81.6642 75.9906 78.3297 79.0393C74.9963 82.0873 33.4258 94.2614 21.4232 77.2575C9.41651 60.2535 20.588 50.4691 24.0888 47.2611C27.5901 44.0531 31.5902 41.1656 26.9241 36.194C22.2532 31.2201 29.5926 26.8893 30.7585 26.5695C31.9268 26.2485 30.6427 19.6082 36.3092 14.7959C41.981 9.98424 48.8498 8.33688 57.2701 11.9751Z",
    fill: "#312C36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7077 51.1669H57.6473V48.573H42.1V51.1642C42.1 53.7028 42.0894 56.4621 39.8789 58.1312V82.9993H49.8737C49.8737 82.9993 55.1072 82.9993 59.8684 82.9993V58.0923C57.7145 56.419 57.7077 53.6837 57.7077 51.1669Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8741 74.4122C46.5682 74.4122 42.3948 71.7108 40.373 70.2954L43.2109 103H58.7582V70.2954C56.2389 72.8834 53.18 74.4122 49.8741 74.4122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 64.8361L41 63L50 74.377L48.5 79L34 64.8361Z",
    fill: "#EDEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 64.8361L59 63L50 74.377L51.5 79L66 64.8361Z",
    fill: "#EDEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7575 63.011C59.1627 63.1215 59.5276 63.1804 59.868 63.2091V58.0935C57.7142 56.4202 57.7073 53.6847 57.7073 51.1679L57.7058 51.1034V48.5095L45.4312 48.574L42.0996 49.6845C44.3207 52.1834 51.1228 60.9288 58.7575 63.011Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4207 34.1358C65.4207 43.029 56.5761 54.1253 49.8735 54.1253C43.1708 54.1253 34.3262 43.029 34.3262 34.1358C34.3262 25.2426 41.287 21.9199 49.8735 21.9199C58.4599 21.9199 65.4207 25.2426 65.4207 34.1358Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5 32C68 34.5 67 36.5 66.5 38.5C66.1 40.1 64 40.8333 63 41V32.5C63.6667 31.5 65.3 30 66.5 32Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7919 32.0164C31.2926 34.5941 32.2921 36.6562 32.7919 38.7183C33.1916 40.368 35.2906 41.1242 36.29 41.296V32.532C35.6237 31.5009 33.9912 29.9543 32.7919 32.0164Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.426 23.0306C57.462 30.3415 61.5339 33.65 65.3514 34.6217C67.4432 35.1542 68.5314 29.5833 68.5314 29.5833C68.5314 29.5833 63.5699 20.9946 63.1998 20.8097C62.8297 20.6245 59.8682 14.1465 59.8682 14.1465L53.2051 19.6992L55.426 23.0306Z",
    fill: "#312C36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 25.9999C43 37.4999 36 38.1666 32 39.4999V29.9999L38.5 20.4999C41.3333 19.6666 48 17.5999 52 15.9999C56 14.3999 57.3333 19.9999 57.5 22.9999C55 21.8333 48.8815 20.5907 47 25.9999Z",
    fill: "#312C36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6373 56.8013C39.5176 58.4911 37.2347 59.679 32.5497 59.679H32.1512C24.8881 59.679 19 65.1482 19 71.8949V99.6686C19 101.508 20.6058 103 22.5867 103H47L40.6373 56.8013Z",
    fill: "#FF7D23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 58.5C38 62 35.3003 69.2 38.5003 76C35.5002 85.5 38.5002 88 46.0002 104.5",
    stroke: "#FDBD90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1104 56.8013C60.2301 58.4911 62.513 59.679 67.198 59.679H67.5964C74.8595 59.679 80.7477 65.1482 80.7477 71.8949V99.6686C80.7477 101.508 79.1419 103 77.161 103H53L59.1104 56.8013Z",
    fill: "#FF7D23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0227 59C62.0232 62.4163 64.7236 69.4441 61.5228 76.0815C64.5236 85.3543 61.5229 87.7946 54.021 103.9",
    stroke: "#FDBD90"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgAttorney);
export default __webpack_public_path__ + "static/media/imgAttorney.ec43a32a15b53bed747d7ab75559bea7.svg";
export { ForwardRef as ReactComponent };